type HttpMethod =
  | "GET"
  | "POST"
  | "PUT"
  | "PATCH"
  | "DELETE"
  | "HEAD"
  | "OPTIONS"

const ALLOWED_HTTP_METHODS: ReadonlySet<string> = new Set<string>([
  "GET",
  "POST",
  "PUT",
  "PATCH",
  "DELETE",
  "HEAD",
  "OPTIONS",
])

export function isHttpMethod(value: unknown): value is HttpMethod {
  return typeof value === "string" && ALLOWED_HTTP_METHODS.has(value)
}
